import _objectSpread from "/opt/render/project/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/opt/render/project/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useMemo } from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import CardHeaderContext from './CardHeaderContext';
import { jsx as _jsx } from "react/jsx-runtime";
var CardHeader = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = _objectWithoutProperties(_ref, ["bsPrefix", "className", "as"]);

  var prefix = useBootstrapPrefix(bsPrefix, 'card-header');
  var contextValue = useMemo(function () {
    return {
      cardHeaderBsPrefix: prefix
    };
  }, [prefix]);
  return /*#__PURE__*/_jsx(CardHeaderContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/_jsx(Component, _objectSpread({
      ref: ref
    }, props, {
      className: classNames(className, prefix)
    }))
  });
});
CardHeader.displayName = 'CardHeader';
export default CardHeader;